import { SignSecret } from '../types/sign'
import release from './release'
import development from './development'

const modes = { release }

export const sharedConfig = {
  // 源地址
  origin: 'http://localhost:12001',

  // 基础请求路径
  httpBaseUrl: '/seaart_base',

  // 发布请求地址
  httpPublishUrl: '/publish',

  googleClientId: '220335438906-n0bj5hqf2rhdkqdl67m5dtrv53b9h74g.apps.googleusercontent.com',

  // 谷歌GTM ID
  gtmId: 'G-K2PZD8KS30',

  // Facebook App ID
  // facebookAppId: '1057817926402871',
  // facebookAppId: '1322751735021693',
  facebookAppId: '599905045514703',

  // discord
  discordClientId: '1370036465500946523',

  // 服务端重定向URI
  serverRedirectUri: 'http://seaart-gateway.sc-api-release.seaart.dev/callback/account/redirect',

  // 登录URI
  loginUri: 'http://localhost:12010/demo/login',

  ...modes[import.meta.env.MODE],

  // 注入配置预留
  secret: undefined,
  clientId: undefined,
}

/**
 * 注入配置
 * @param config 配置对象
 */
export const injectSecretConfig = (secret: SignSecret) => {
  sharedConfig.secret = secret
}

/**
 * 注入客户端ID
 * @param clientId 客户端ID
 */
export const injectClientId = (clientId: string) => {
  sharedConfig.clientId = clientId
}

console.debug('[sharedConfig] :>> ', sharedConfig)

export default sharedConfig
